// Operation Expense Categories
export const OPERATION_EXPENSE_CATEGORIES = [
    'general_operations',
    'office',
    'salaries',
    'marketing',
    'sales',
    'technology',
    'training',
    'travel',
    'utilities',
    'insurance',
    'legal',
    'maintenance',
    'supplies',
    'other',
] as const

export type OperationExpenseCategory =
    (typeof OPERATION_EXPENSE_CATEGORIES)[number]

// Main Operation Expense Interface
export interface OperationExpense {
    id: number
    expense_name: string
    category: OperationExpenseCategory
    amount: number
    currency: string
    report_month: string // YYYY-MM format
    notes?: string
    description?: string
    created_at: string
    updated_at: string
    deleted_at?: string | null
}

// Create Single Expense Request
export interface CreateOperationExpenseRequest {
    expense_name: string
    category: OperationExpenseCategory
    amount: number
    currency: string
    expense_month: string // YYYY-MM format
    notes?: string
    description?: string
}

// Batch Item Request (for batch create)
export interface BatchExpenseRequest {
    expense_name: string
    category: OperationExpenseCategory
    amount: number
    notes?: string
    description?: string
}

// Batch Create Request
export interface BatchCreateOperationExpensesRequest {
    report_month: string // YYYY-MM format
    currency: string
    expenses: BatchExpenseRequest[]
}

// Update Request
export interface UpdateOperationExpenseRequest {
    expense_name?: string
    category?: OperationExpenseCategory
    amount?: number
    currency?: string
    notes?: string
    description?: string
}

// List Params (with filters)
export interface OperationExpenseListParams {
    from_month?: string // YYYY-MM format
    to_month?: string // YYYY-MM format
    categories?: OperationExpenseCategory[] // Filter by multiple categories
    expense_month?: string // Filter by specific month
}

// Monthly Summary
export interface OperationExpenseSummary {
    expense_month: string
    category?: OperationExpenseCategory // Optional: if grouped by category
    total_amount: number
    currency: string
    expense_count: number
}

// Category Summary
export interface CategorySummary {
    category: OperationExpenseCategory
    total_amount: number
    currency: string
    expense_count: number
    from_month?: string
    to_month?: string
}

// Summary Params
export interface SummaryParams {
    from_month?: string
    to_month?: string
    group_by_category?: boolean
}

// Category Summary Params
export interface CategorySummaryParams {
    from_month?: string
    to_month?: string
}
